import React from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

// to deprecate, this shields props when better to use ReactDatePicker directly, advise against using it.
export function DatePicker2({ date, handleDateChange, max, min }) {
  const handleChange = (date) => handleDateChange(date);
  return <DatePicker selected={date} onChange={handleChange} maxDate={max || null} minDate={min || null} />;
}
